import React, { Suspense, lazy } from 'react';
import { Spin } from 'antd';
import { Switch, Route, useRouteMatch, useParams } from 'react-router-dom';
import { setBizCode } from '../services/business-details-service';
import KioskAdminLayout from '../layout/kiosk-admin-layout';
import { useScrollPosition } from '../utilities/scroll-position-context';

const Maintenance = lazy(() => import('../pages/pg-maintenance/pg-maintenance'));
// kiosk pages
const AppsSelectList = lazy(() => import('../kiosk/pages/pg-apps-select-list'));
const AppDetails = lazy(() => import('../kiosk/pages/pg-home'));
const TxnCreate = lazy(() => import('../kiosk/pages/pg-txn-create'));
const TxnList = lazy(() => import('../kiosk/pages/pg-txn-list'));
const TxnView = lazy(() => import('../kiosk/pages/pg-txn-view'));
const TxnEdit = lazy(() => import('../kiosk/pages/pg-txn-quickactions/pg-txn-quickactions'));

function Admin() {
    const { path } = useRouteMatch();
    const { bizCode } = useParams();
    const { restoreScrollPosition } = useScrollPosition();
    restoreScrollPosition();
    setBizCode(bizCode);

    return (
        <Suspense
            fallback={
                <div className="spin">
                    <Spin />
                </div>
            }
        >
            <Switch>
                <Route exact path={`${path}/kiosk/apps/list`} component={AppsSelectList} />
                <Route exact path={`${path}/kiosk/apps`} component={AppDetails} />
                <Route exact path={`${path}/kiosk/services/txn/create/:serviceType/:perspectiveId`} component={TxnCreate} />
                <Route exact path={`${path}/kiosk/services/txn/list/:serviceType/:perspectiveId`} component={TxnList} />
                <Route exact path={`${path}/kiosk/services/txn/view/:txnId/:serviceType/:perspectiveId`} component={TxnView} />
                <Route exact path={`${path}/kiosk/services/txn/edit/:txnId/:serviceType/:perspectiveId`} component={TxnEdit} />
                <Route path="*" component={Maintenance} />
            </Switch>
        </Suspense>
    );
}
export default KioskAdminLayout(Admin);